import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { FadeLoader } from 'react-spinners';

// Date Format
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import { config } from 'container/data/models';
import Conversation from './Conversation';
import { Tooltip } from 'react-tooltip';
import theme from 'container/theme';
import assets from 'assets';

dayjs.extend(utc);
dayjs.extend(relativeTime);

function InputContainer() {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector(state => state.auth);
  // const model = useSelector((state) => state.chat.model);

  const { isLeftSideBarOpen, openMobileChatMenu } = useSelector(
    state => state.utils
  );

  const conversations = useSelector(state => state.chat.conversations);
  const selected = useSelector(state => state.chat.selectedConversation);
  const timeFilter = useSelector(state => state.chat.timeFilter);
  const loading = useSelector(state => state.chat.responseLoading);
  const imageLoading = useSelector(state => state.imageGeneration.loading);
  const model = useSelector(state => state.chat.model);
  const [search, setSearch] = useState('');

  // Sort Conversations var
  const [convoLoading, setConvoLoading] = useState(false);
  const [sortedConversations, setSortedConversations] = useState([]);
  const handleSelect = conversation => {
    dispatch.chat.setSelectedConversation(conversation);
  };

  const handleClick = () => {
    if (!loading && !imageLoading) {
      dispatch.chat.setSelectedConversation(null);
      dispatch.chat.setMessages([]);
      dispatch.imageGeneration.setSelectedFilter('');
      dispatch.imageGeneration.setSelectedImage('');
      dispatch.imageGeneration.setSelectedTemplate('');
      dispatch.imageGeneration.setCustomPrompt('');
    }
  };

  //
  const handleDelete = (e, id) => {
    e.stopPropagation();
    dispatch.chat.deleteConversation(id);
  };

  useEffect(() => {
    if (isLoggedIn && model) {
      let query = `?model=${model.value}`;
      if (timeFilter === 'recent') {
        query += `&most_recent=true`;
      } else if (timeFilter === 'favourite') {
        query += `&favourite=true`;
      }
      setTimeout(() => {
        dispatch.chat.getAllConversations(query);
      }, 100);
    }
    // eslint-disable-next-line
  }, [isLoggedIn, timeFilter, openMobileChatMenu, model]);

  useEffect(() => {
    if (isLoggedIn && model) {
      dispatch.chat.setTimeFilter('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, model]);

  //sort conversations functions
  const sortArray = async () => {
    setConvoLoading(true);
    const sortedConvoArray = await sortArrayByLatestDate([...conversations]);
    setSortedConversations([...sortedConvoArray]);
    setConvoLoading(false);
  };

  const sortArrayByLatestDate = arr => {
    return arr.sort((a, b) => {
      const dateA = new Date(a.updated_at);
      const dateB = new Date(b.updated_at);

      return dateB - dateA;
    });
  };

  useEffect(() => {
    if (isLoggedIn) {
      sortArray();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversations]);

  const getIcon = model => {
    const data = config.find(item => item.value === model);
    return (
      <img
        src={data?.image}
        alt={data?.value}
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '5px',
          marginTop: '-2px',
        }}
      />
    );
  };

  return (
    <div className='input__container'>
      {/* Search Field / Add button */}
      <div className='input__container-main'>
        <div
          style={{
            width: isLeftSideBarOpen ? '' : '0px',
            transition: '0.4s ease',
            minWidth: '0px',
            flexGrow: isLeftSideBarOpen ? 1 : 0,
            overflow: 'hidden',
          }}
        >
          <input
            name='search-chat'
            id='search-chat'
            type='text'
            className=''
            placeholder='Search Chats'
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <button
          id='new-chat'
          type='submit'
          onClick={handleClick}
          style={{
            cursor: loading ? 'not-allowed' : 'pointer',
            width: isLeftSideBarOpen ? '30px' : '40px',
            height: isLeftSideBarOpen ? '30px' : '40px',
          }}
        >
          <img src={assets.plus} alt='' />
        </button>
        <Tooltip
          anchorSelect='#new-chat'
          content='Create new chat'
          style={{ zIndex: '100', background: theme.colors.lightgrey }}
        />
      </div>
      {!isLeftSideBarOpen && (
        <a
          href='https://help.chatai.com/hc/en-us'
          target='_blank'
          rel='noreferrer'
          id='help-btn-sm'
        >
          <div
            className=''
            style={{
              marginLeft: '20px',
              marginTop: '15px',
              width: '40px',
              height: '40px',
              display: 'grid',
              placeItems: 'center',
              backgroundColor: '#3E404D',
              borderRadius: '6px',
            }}
          >
            <div className='support-grid'>
              <img src={assets.help} alt='' />
            </div>
          </div>
          <Tooltip
            anchorSelect='#help-btn-sm'
            content='Help center'
            style={{ zIndex: '100', background: theme.colors.lightgrey }}
          />
        </a>
      )}
      {/* Conversations */}
      {convoLoading ? (
        <div className='m-auto'>
          <FadeLoader color='#ffffff' />
        </div>
      ) : (
        isLeftSideBarOpen && (
          <div className='conversations__main' style={{ paddingRight: '5px' }}>
            {sortedConversations?.map(conversation => {
              if (
                conversation.label.toLowerCase().indexOf(search.toLowerCase()) >
                -1
              ) {
                return (
                  <Conversation
                    key={conversation.id}
                    conversation={conversation}
                    handleDelete={handleDelete}
                    loading={loading}
                    handleSelect={handleSelect}
                    selected={selected}
                    getIcon={getIcon}
                  />
                );
              } else {
                return null;
              }
            })}
          </div>
        )
      )}
    </div>
  );
}

export default InputContainer;
